import * as React from 'react';
import { Numberbox, Validation, ValidationLevel, ValidationProps } from 'ui';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { getValue } from './get-value';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import styles from './filter-decimal.scss';

export class FilterDecimalRange extends React.PureComponent<FilterCommonProps<number>> {
  private onChangeRange = (value: number, subOptionType: SubOptionType) => {
    const { values } = this.props;

    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType: SubOptionType.decimalFrom,
      value: subOptionType === SubOptionType.decimalFrom ? value : getValue(values, SubOptionType.decimalFrom).value
    }, {
      optionType: OptionType.specified,
      subOptionType: SubOptionType.decimalTo,
      value: subOptionType === SubOptionType.decimalTo ? value : getValue(values, SubOptionType.decimalTo).value
    }].filter(v => isDefinedIncludingZero(v.value)) || []);
  }

  private onChangeRangeFrom = (value: number) => this.onChangeRange(value, SubOptionType.decimalFrom);
  private onChangeRangeTo = (value: number) => this.onChangeRange(value, SubOptionType.decimalTo);

  public render() {
    const { id, values, locale, translation } = this.props;

    const rangeFrom = getValue(values, SubOptionType.decimalFrom);
    const rangeTo = getValue(values, SubOptionType.decimalTo);
    const invalidRange = rangeFrom.value > rangeTo.value;
    const validation = invalidRange && { level: ValidationLevel.error } as ValidationProps;

    return <>
      <h3>{translation.filters_decimal_range}</h3>
      <div className="row">
        <div className="col col-md-6">
          <Numberbox
            className={styles.input}
            componentId={`${id}_decimal_from`}
            locale={locale}
            value={rangeFrom.value}
            onChange={this.onChangeRangeFrom}
            useThousand=" "
            minValue={-999999999999999.999999999999999}
            maxValue={999999999999999.999999999999999}
            maxDecimals={15}
            validation={validation}
            textInvalidRangeError={translation.must_be_within_range}
          />
        </div>
        <div className="col col-md-6">
          <Numberbox
            className={styles.input}
            componentId={`${id}_decimal_to`}
            locale={locale}
            value={rangeTo.value}
            onChange={this.onChangeRangeTo}
            useThousand=" "
            minValue={-999999999999999.999999999999999}
            maxValue={999999999999999.999999999999999}
            maxDecimals={15}
            validation={validation}
            textInvalidRangeError={translation.must_be_within_range}
          />
        </div>
        {invalidRange && <div className={styles.validationError}>
          <Validation
            level={ValidationLevel.error}
            messages={[
              {
                level: ValidationLevel.error,
                message: translation.filters_must_be_withing_range
              }]}
          />
        </div>}
      </div>
    </>;
  }
}
